import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, constants, Typography } from '@match/react-component-library';
import { messages } from '../Greeting';

const { FONT_SIZE, FONT_WEIGHT } = constants;

export const SC3Greeting: React.FunctionComponent = () => {
  return (
    <Box display="flex" flexDirection="column" flex="1 0 auto">
      <Typography fontSize={FONT_SIZE.XXLARGE} fontWeight={FONT_WEIGHT.BOLD}>
        <FormattedMessage {...messages.howCanWeHelp} />
      </Typography>
    </Box>
  );
};
